<template>
  <li class="list-item">
    <div class="col-module">
      <span>Module: </span><span>{{ props.record.moduleName }}</span>
    </div>
    <div class="col-theme">
      <span>Theme: </span><span>{{ props.record.themeName }}</span>
    </div>
    <div class="col-theme">
      <span>Client: </span><span>{{ props.record.clientID }}</span>
    </div>
    <div class="col-date">
      <span>Date: </span><span>{{ $filters.simpleDate(props.record.startTime) }}</span>
    </div>
    <div class="col-time">
      <span>Duration: </span><span>{{ $filters.duration(props.record.endTime, props.record.startTime) }}</span>
    </div>
  </li>
</template>

<script setup>
const props = defineProps({
  record: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style scoped>
.list-item {
  display: grid;
  row-gap: 0.5em;
  border-bottom: 1px solid #a7a9ac;

  margin: 0 0.5em;
  padding: 1em 0.5em;
}

.list-item > div > span:first-child {
  margin-right: 0.5em;
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .list-item {
    grid-template-areas: 'a b c d e';
    grid-template-columns: 26% 20% 16% 20% 10%;
    justify-content: space-between;
    align-items: center;
    margin: 0 2em;
    min-height: 2em;
  }

  .list-item > div > span:first-child {
    display: none;
  }
}
</style>
